<template>
  <div class="wwstatus" v-if="workerMessage === 'offline'">
    <ReCloudOffLine/>
  </div>
  <div class="wwstatus" v-else-if="workerMessage === 'sync'">
    <IcCloudSync/>
  </div>
  <div class="wwstatus" v-else-if="workerMessage === 'online'">
    <IcCloud/>
  </div>
  <div class="wwstatus" v-else-if="workerMessage === 'unauthorized'">
    <CaVirtualPrivateCloud/>
  </div>
</template>

<script>
import { ref, isProxy, toRaw, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';
//import timeoutWorker from '@/components/WebWorker';
import { OnOffline } from "@/services/OnOffline";
import { SystemToDo } from '@/models/SystemToDo';
import { AppUsers } from '@/models/AppUsers';
import { DataSync } from '@/models/DataSync';
import { ReCloudOffLine, IcCloudSync, IcCloud, CaVirtualPrivateCloud  } from '@kalimahapps/vue-icons';
import { SmartWearableData } from "@/models/SmartWearableData";

//const worker = new Worker('./timeoutWorker.js', { type: 'module' });
//const worker = new Worker(new URL("WebWorker/timeoutWorker.js", import.meta.url))
//console.log('wwewe')
//const send = message => worker.postMessage({
//  message
//})

export default {
props: {
  isUser: Object,
  isRef: Number,
},
components:{
  ReCloudOffLine,
  IcCloudSync,
  IcCloud,
  CaVirtualPrivateCloud
},
data() {
  return {
    workerMessage: "oflline",
    lastCheckTS: 0,
    workerStatus: 'inactive',
    lastThyveCheck: 0,
    //worker: new Worker(new URL("@/components/WebWorker/timeoutWorker.js", import.meta.url)),
  }
},
mounted() {
  
  
  window.addEventListener("pointerup", (event) => {
    let startImmediately = false;
    if(typeof event.target.type != 'undefined'){
      //console.log(event.target.type)
      if(event.target.type == 'submit'){
        startImmediately = true;
      }
    }else{
      if(typeof event.srcElement.parentElement != 'undefined'){
        if(event.srcElement.parentElement.type == 'submit'){
          startImmediately = true;
        }
      }
    }
    if(startImmediately === true){
      this.lastCheckTS = 0;
    }
    
    this.startWorker();
    //this.inititateSmartWearables();
  });

},
methods: {
  async startWorker(){
    
    let User = toRaw(this.isUser)
    if(!location.href.includes("deletedata"))
    if(typeof User.isUser != 'undefined')
      if(AppUsers.hasBackend(User.isUser) !== false){
          console.log('doSync')
          return await this.getOnlineStatus().then((res) => {
            if((res === true) && (this.workerStatus != 'active')){
              console.log('syncstart')
              if(this.isThryveTimeToStart()){
                console.log('syncstart smart wearables')
                this.workerStatus = 'active';
                this.inititateSmartWearables().then((thryveRes) => {
                  let resOK = true;
                  if(thryveRes == 'unauthorized'){
                    this.setMessage('unauthorized');
                    this.workerStatus = 'unauthorized'
                    location.href = '#/login';
                    resOK=false;
                  }
                  return resOK
                }).then((resOK) => {
                  if(resOK){
                    this.workerStatus = 'inactive'
                    this.getOnlineStatus();
                    let myEvent = new Event("dataSyncFinished")
                  }
                })
              }else{
                
              
                if(this.isTimeToStart()){
                  console.log('syncstart backend')
                  this.workerStatus = 'active';
                  return  SystemToDo.getToToDo(User.isUser.sysId).then((todoRes) => {
                      this.setMessage('sync');
                      // do sync from here
                      // ToDo: place here the real WebWorker
                      DataSync.sendNewDataToServer(todoRes).then((serverRes) => {
                        let resOK = true;
                        if(serverRes == 'unauthorized'){
                          this.setMessage('unauthorized');
                          this.workerStatus = 'unauthorized'
                          location.href = '#/login';
                          resOK=false;
                        }
                        return resOK
                      }).then((resOK) => {
                        if(resOK){
                          this.workerStatus = 'inactive'
                            this.getOnlineStatus();
                            let myEvent = new Event("dataSyncFinished")
                        }
                      });
                  // }
                    
                  }) // getTodo
                }
              }
            }else{
              this.setMessage('offline');
            }
          })
        
      }
  },

  isTimeToStart(){
    // do check only, if min 10 seconds are since last check
    if( (Math.floor(Date.now() / 1000)-this.lastCheckTS) > 100){
      this.lastCheckTS = Math.floor(Date.now() / 1000)
      return true;
    }else{
      return false;
    }
  },
  
  async inititateSmartWearables(){
      let MySmartWearableData = new SmartWearableData();
       return await MySmartWearableData.updateLocalWithOneYearProviderData()
  },

  isThryveTimeToStart(){
    // do check only, if min 30 Minutes are since last check
    if( (Math.floor(Date.now() / 1000)-this.lastThyveCheck) > 30*60){
      this.lastThyveCheck = Math.floor(Date.now() / 1000)
      return true;
    }else{
      return false;
    }
  },

  setMessage(text){
    this.workerMessage = text;
  },

  async getOnlineStatus() {
    if(this.workerStatus == 'unauthorized'){
      return false;
    }
    if(this.workerStatus == 'active'){
      console.log('protect double datasync request');
     // this.setMessage('online');
      return false;
    }

    let onlineStatus = (async function (){
        return await OnOffline.isOnOffline()
    });
    
    return  onlineStatus().then(
      (fulfilledResult) => {
        this.setMessage('online');
        return true;
      },
      (rejectedResult) => {
        this.setMessage('offline');
        return false;
      },
    );
  }
},
setup() {


  //const onlineStatus = ref(null)
  const workerMessage = ref(null)
  return {
    workerMessage,
    //onlineStatus
  }
}
}
</script>
<style>
.wwstatus > svg{
vertical-align: middle;
}
</style>